import React from 'react'
import { ErrorAlert } from 'components/errorAlert/ErrorAlert'
import styled from 'styled-components'
import { getTranslation } from 'utils/translation'

const StyledRoleList = styled.div`
  .role-list {
    list-style: disc;
    padding-left: 1.4rem;
    font: var(--body-small-600);
  }
`

export const Error403 = ({
  title,
  description,
  isBackButton,
  requiredRole,
}: {
  title?: string
  description?: string
  isBackButton?: boolean
  requiredRole?: string[]
}) => {
  return (
    <ErrorAlert
      title={title ? title : getTranslation('message', 'ERROR.FORBIDDEN')}
      errorCode={403}
      buttonTitle={getTranslation('resource', 'GO_BACK')}
      onClick={isBackButton ? () => window.history.back() : undefined}
    >
      <StyledRoleList>
        <p>{description ? description : getTranslation('message', 'INFO.CONTACT_FOR_INQUIRIES')}</p>
        {requiredRole && (
          <ul className="role-list">
            {requiredRole.map((role) => (
              <li key={role}>{role}</li>
            ))}
          </ul>
        )}
      </StyledRoleList>
    </ErrorAlert>
  )
}
